<template>
	<div class="animated fadeIn">
		<b-row>
			<b-col md="12">
				<b-card>
					<template v-slot:header>
						<b-row>
							<b-col md="6">
								<strong>Proyectos</strong>
							</b-col>
							<b-col md="6" class="d-flex justify-content-end">
								<div v-if="loading" class="ml-2">
									<b-spinner variant="primary" label="Spinning" small></b-spinner>
								</div>
							</b-col>
						</b-row>
					</template>
					<b-card-body class="table-responsive">
						<b-row class="justify-content-between">
							<b-col md="6">

							</b-col>
							<b-col md="4">
								<b-form-group>
									<label class="m-0"><strong class="text-black-50">Buscar:</strong></label>
									<b-input v-model="filter" type="search"></b-input>
								</b-form-group>
							</b-col>
						</b-row>
						<b-table :items="projects"
								 :current-page="currentPage"
								 :per-page="perPage"
								 :fields="projectTableFields"
								 :busy="loading"
								 :sort-by.sync="sortBy"
								 :sort-desc.sync="sortDesc"
								 :filter="filter"
								 :filter-included-fields="filterOn"
								 show-empty
								 striped
								 empty-filtered-text="No hay proyectos disponibles"
								 empty-text="No hay proyectos disponibles"
								 head-variant="light"
								 sort-icon-left
								 @filtered="onFiltered">
							<template v-slot:table-busy>
								<div class="text-center text-info my-2">
									<b-spinner class="align-middle"></b-spinner>
								</div>
							</template>
							<div slot="CreatedOn" slot-scope="item">
								{{ item.item.CreatedOn | dateFormatFull }}
							</div>
							<div slot="PhaseLabel" slot-scope="item">
								<i :class="item.item.Phase | iconProjectPhase"></i> {{ item.item.PhaseLabel }}
							</div>
							<div slot="detail" slot-scope="item">
								<router-link :to="{name: 'ProjectDetail', params: {id: item.item.ProjectId}}">
									Ver Detalle
								</router-link>
							</div>
						</b-table>
						<nav class="d-flex justify-content-center" v-if="totalRows > perPage">
							<b-pagination
								:total-rows="totalRows"
								:per-page="perPage"
								v-model="currentPage"
								prev-text="<<"
								next-text=">>"
								hide-goto-end-buttons/>
						</nav>
					</b-card-body>
				</b-card>
			</b-col>
		</b-row>
	</div>
</template>

<script>
import GoBackComponent from "@/components/GoBackComponent";
import {mapActions, mapState} from "vuex";

export default {
	name: "ProjectList",
	components: {
		GoBackComponent
	},
	data: function () {
		return {
			loading: false,
			projects: [],
			perPage: 10,
			currentPage: 1,
			projectTableFields: {
				Number: {
					label: "Número",
					sortable: true,
				},
				PhaseLabel: {
					label: "Fase del Proyecto"
				},
				Name: {
					label: "Nombre del Proyecto",
					sortable: true,
				},
				CreatedOn: {
					label: "Fecha de Creación",
					sortable: true,
				},
				detail: {
					label: "Detalles"
				}
			},
			sortBy: 'Number',
			sortDesc: false,
			filter: '',
			filterOn: []
		}
	},
	mounted() {
		this.loading = true;

		this.getProjects()
			.then((projects) => {
				this.projects = projects;
			})
			.catch((err) => {
				console.log(err);
			})
			.finally(() => {
				this.loading = false;
			})
	},
	methods: {
		...mapActions([
			'getProjects'
		]),
		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length;
			this.currentPage = 1
		}
	},
	computed: {
		totalRows: function () {
			return this.projects.length;
		}
	}
}
</script>

<style scoped>

</style>
